import {
  ConnectDatabaseRequest,
  ConnectDatabaseResponse,
  CONNECTION_STATUS_URL,
  ConnectionStatusResponse,
  ConnectRequest,
  ConnectResponse,
  RedirectParams,
} from 'src/models';
import axios, { ACCOUNTING_PLATFORM } from '../axios';

export function getIntegrationConnectionStatus() {
  return axios.request<ConnectionStatusResponse>({
    method: 'get',
    url: CONNECTION_STATUS_URL,
  });
}

export function connectIntegration(data: ConnectRequest) {
  return axios.request<ConnectResponse>({
    method: 'post',
    url: `${ACCOUNTING_PLATFORM}/oauth/connect`,
    data,
  });
}

export function redirectIntegration(data: RedirectParams) {
  return axios({
    method: 'post',
    url: `${ACCOUNTING_PLATFORM}/oauth/redirect`,
    data,
  });
}

export function getDatabaseList(data: ConnectRequest) {
  return axios.request<ConnectDatabaseResponse>({
    method: 'get',
    url: `${ACCOUNTING_PLATFORM}/database?platform=${data.platform}`,
  });
}

export function connectDatabase(data: ConnectDatabaseRequest) {
  return axios.request({
    method: 'post',
    url: `${ACCOUNTING_PLATFORM}/database`,
    data,
  });
}

export function disconnectIntegration(data: ConnectRequest) {
  return axios({
    method: 'post',
    url: `${ACCOUNTING_PLATFORM}/oauth/disconnect`,
    data,
  });
}
